
import {BaseEntity} from "../common/base-entity";
import {Telephone} from "../shared/telephone";
import {Address} from "../shared/address";
import {TelephoneTypes} from "../shared/telephone-types";
import {AddressTypes} from "../shared/address-types";
import {FormArray, FormControl, FormGroup} from "rx-form-mapper";


export class ReferredClient extends BaseEntity {
    @FormControl()
    id : string;
    @FormControl()
    firstName : string ;
    @FormControl()
    middleName : string ;
    @FormControl()
    lastName : string ;
    @FormControl()
    role : string;
    @FormControl()
    email : string ;
    @FormArray(Telephone)
    telephones : Telephone[] = [];
    @FormGroup()
    address : Address;
    constructor(referredClient?: ReferredClient) {
        super(referredClient);
        if (referredClient) {
            this.telephones = [];
            if (referredClient.telephones) {
                this.populatePhones(referredClient, [TelephoneTypes.home, TelephoneTypes.cell, TelephoneTypes.work]);
            }
            if(referredClient.address){
                referredClient.address = new Address(referredClient.address);
            }
        }
        if(!this.telephones || this.telephones.length == 0) {
            this.telephones = [];
            this.initializePhones([TelephoneTypes.home, TelephoneTypes.cell, TelephoneTypes.work]);
        }
        if(!this.address) {
            this.address = new Address();
            this.address.addressTypeCode = AddressTypes.mailing;
        }
    }

    populatePhones(referredClient: ReferredClient, phoneTypes: string[]): void {
        for (const phoneType of phoneTypes) {
            let phone: Telephone = referredClient.telephones.find((t: Telephone) => t.phoneTypeCode === phoneType);
            if (phone) {
                this.telephones.push(new Telephone(phone));
            } else {
                phone = new Telephone();
                phone.phoneTypeCode = phoneType;
                this.telephones.push(phone);
            }
        }
    }

    initializePhones(phoneTypes : string[]) : void {
        for(let phoneType of phoneTypes) {
            let phone : Telephone = this.telephones.find((t : Telephone) => t.phoneTypeCode === phoneType);

            if(!phone) {
                phone = new Telephone();

                phone.phoneTypeCode = phoneType;

                this.telephones.push(phone);
            }
        }
    }

    get fullName(): string {
        return [this.firstName, this.middleName, this.lastName].filter(Boolean).join(' ');
    }
}
